export default __webpack_public_path__ + "static/media/contact_us.c37d7df8.png";